// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setISOWeek as fn } from "../setISOWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setISOWeekWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default setISOWeekWithOptions;
